import { defineStore } from 'pinia';
import { axios } from '@/Services/Backend';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { useAffinityOrderStore } from '@/Stores/affinityorder';
import { useNotificationsStore } from '@/Stores/notifications';

export const useBranchStore = defineStore('branch', {
    state: () => ({
        branch: null,
        has_pending_products: false,
        is_mobile:false
    }),

    actions: {
        setBranch(branch, pendingCartId = null) {
            this.branch = branch;

            useNormalOrderStore().reloadFromLocalStorage();
            useAffinityOrderStore().reloadFromLocalStorage();

            // The remote cart of this branch has to be loaded before anything can be sent to the server
            if (branch) useNormalOrderStore().markCartUnsynced();

            // For the current branch, get the shopping cart in the database
            window.EventBus.$emit('refresh-shared-cart', { pendingCartId });
        },

        setHasPendingProducts(value) {
            this.has_pending_products = value;
        },

        /// A new branch was selected - notify the backend so that we can use it in future sessions.
        setBranchNotify(branch, inertia, userId, sellerId = null, pendingCartId = null) {
            axios
                .post('/api/user/branch', { branch_id: branch.id })
                .then(() => {
                    const prevBranchId = this.branch?.id;
                    this.setBranch(branch, pendingCartId);
                    useNormalOrderStore().clearAllOldCarts(userId, branch.id, ['products', 'campaigns', 'baseCampaigns', 'productsAffinity', 'pendingCart', 'pendingCartId','deliveryAddress','orderAdditionalInfo','observation','orderAdditionalInfoAffinity','deliveryAddressAffinity','observationAffinity']);

                    if (pendingCartId > 0) {
                        // Don't notify us while interacting with a pending cart
                        useNotificationsStore().unsubscribeSharedCart(branch.id, sellerId);
                    } else {
                        // Subscribe to the target shared cart
                        useNotificationsStore().subscribeSharedCart(branch.id, prevBranchId, userId, sellerId);
                    }
                })
                .catch((error) => {
                    this.setBranch(null);
                    console.error(error);
                    if (inertia && error.response.status === 403) inertia.visit('/error', { data: { message: error.response.data.message } });
                });
        },
        setIsMobile(value) {
            this.is_mobile = value;
        },
    },

    getters: {
        getDeliveryAddresses: (state) => state.branch?.addresses ?? [],
        isBlocked: (state) => [4, 5, 6, 10].includes(state.branch?.account_status?.id) || state.branch?.account_status?.is_locked,
        cannotPurchase: (state) => [7, 16].includes(state.branch?.account_status?.id),
        hasPendingProducts: (state) => state.has_pending_products ?? false,
        hideCampaigns: (state) => state.no_campaigns ?? false,
        isMobile: (state) => state.is_mobile ?? false,
    },
});
